const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  tags: [],
  search: "",
  page: 1,
  limit: 8,
  author: "",
};

const filterSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    tagSelected: (state, action) => {
      state.tags.push(action.payload);
    },
    tagRemoved: (state, action) => {
      const indexToRemove = state.tags.indexOf(action.payload);

      if (indexToRemove !== -1) {
        state.tags.splice(indexToRemove, 1);
      }
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
    pageSelected: (state, action) => {
      state.page = action.payload;
    },
    authorSelected: (state, action) => {
      return (state = { ...initialState, author: action.payload });
    },
    clearFilter: (state, action) => {
      return initialState;
    },
    limitSet: (state, action) => {
      state.limit = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const {
  tagSelected,
  tagRemoved,
  searched,
  pageSelected,
  authorSelected,
  clearFilter,
  limitSet,
} = filterSlice.actions;
export const filterInitialState = initialState;
